import { Component, OnInit } from '@angular/core';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-data-bank-stp1',
  templateUrl: './data-bank-stp1.component.html',
  styleUrls: ['./data-bank-stp1.component.css']
})
export class DataBankSTP1Component implements OnInit {
  currentdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  currenttime = formatDate(new Date(),  'HH:mm', 'en');
  constructor() { }

  ngOnInit(): void {
  }



}
